export default "__VITE_ASSET__DbTId3Eg__"